<template>
  <div>
    <div class="container mobile-logo">
      <div class="row">
        <div class="col-md-12">
          <img class="mb-4" src="../../assets/img/logo.png" alt="Logo" width="200" height="110" />
        </div>
      </div>
    </div>
    <div class="container-fluid checkout-mobile">
      <div class="container">
        <div class="row checkout">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <table>
              <tr>
                <td class="cart-ico">
                  <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"
                    ></path>
                  </svg>
                </td>
                <td v-on:click="toggleMobileSummaryVisibility">
                  <span v-if="!displaySummaryInMobileLayout"
                    >Show Order Summary
                    <svg width="11" height="6" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile" fill="#000">
                      <path
                        d="M.504 1.813l4.358 3.845.496.438.496-.438 4.642-4.096L9.504.438 4.862 4.534h.992L1.496.69.504 1.812z"
                      ></path>
                    </svg>
                  </span>
                  <span v-if="displaySummaryInMobileLayout">
                    Hide Order Summary
                    <svg width="11" height="7" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile" fill="#000">
                      <path
                        d="M6.138.876L5.642.438l-.496.438L.504 4.972l.992 1.124L6.138 2l-.496.436 3.862 3.408.992-1.122L6.138.876z"
                      ></path>
                    </svg>
                  </span>
                </td>
                <td class="price" v-if="this.subscription.products.length > 0">
                  {{this.countrySetting.currencySymbol}} {{ this.subscription.grandTotalInSelectedCurrency.toFixed(2) }}
                </td>
              </tr>
            </table>
            <transition name="fade">
              <div v-if="displaySummaryInMobileLayout">
                <CheckoutProducts
                  v-if="this.subscription.plan != null"
                  v-bind:plan="this.subscription.plan"
                  v-bind:products="this.subscription.products"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutProducts>
                <CheckoutSummary
                  v-bind:subscription="subscription"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutSummary>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row checkout">
        <div class="col-lg-1 col-md-2 d-none d-lg-block d-md-block"></div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <div class="row">
            <div class="col-md-3">
              <img
                stle="margin-left:-39px"
                class="mb-4 desktop-logo"
                src="../../assets/img/logo.png"
                alt="Logo"
                width="200"
                height="110"
              />
            </div>
          </div>
          <div class="row">
            <div class="content-box">
              <h5>Thank you {{ customer.firstName }}!</h5>
              <br />
              <h6>Order# {{ orderId }}</h6>
              <h6>Your order is confirmed.</h6>
              <p>
                A confirmation email with the invoice has been sent to <strong> {{ customer.email }}</strong
                >. If you have any trouble getting your order please contact us at
                <a href="mailto:support@gofar.co">support@gofar.co</a>
              </p>
              <br />
              <p>
                <router-link
                  :to="{
                    path: '/checkout',
                    query: {
                      products: this.selectedProductIds,
                      plan: this.subscription.plan.id,
                      quantity: this.subscription.quantity,
                      country_code: this.customer.country
                    }
                  }"
                >
                  Place another order
                </router-link>
              </p>
            </div>
            <div class="content-box">
              <div class="row">
                <div class="col-lg-12">
                  <h4>Contact information</h4>
                  <p>
                    Email:&nbsp;<span v-if="customer">{{ customer.email }}</span>
                  </p>
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <h4>Shipping address</h4>
                  <p>
                    <span>{{ customer.firstName }} {{ customer.lastName }}<br /></span>
                    <span>{{ customer.address }}<br /></span>
                    <span>{{ customer.line2 }}<br /></span>
                    <span>{{ customer.line3 }}<br /></span>
                    <span>{{ customer.postalCode }}<br /></span>
                    <span>{{ customer.city }}<br /></span>
                    <span>{{ customer.stateCode }}<br /></span>
                    <span>{{ customer.country }}<br /></span>
                  </p>
                  <h4>Shipping Method</h4>
                  <p>
                    {{ this.subscription.selectedShippingOption.name }}
                  </p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <h4>Billing address</h4>
                  <p>
                    <span>{{ customer.firstName }} {{ customer.lastName }}<br /></span>
                    <span>{{ customer.address }}<br /></span>
                    <span>{{ customer.line2 }}<br /></span>
                    <span>{{ customer.line3 }}<br /></span>
                    <span>{{ customer.postalCode }}<br /></span>
                    <span>{{ customer.city }}<br /></span>
                    <span>{{ customer.stateCode }}<br /></span>
                    <span>{{ customer.country }}<br /></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <CheckoutFooter></CheckoutFooter>
        </div>
        <div class="col-lg-1 col-md-12 col-sm-12"></div>
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 checkout-right-panel">
          <CheckoutProducts
            v-if="this.subscription.plan != null"
            v-bind:plan="this.subscription.plan"
            v-bind:products="this.subscription.products"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutProducts>
          <CheckoutSummary
            v-bind:subscription="subscription"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutSummary>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { InputFacade } from 'vue-input-facade';

import CheckoutProducts from './components/CheckoutProducts';
import CheckoutSummary from './components/CheckoutSummary';
import CheckoutFooter from './components/CheckoutFooter';

import * as chargebeeCheckout from '../../helpers/chargebee-checkout';

export default {
  name: 'CheckoutFinish',
  components: { CheckoutSummary, CheckoutFooter, InputFacade, CheckoutProducts },
  data() {
    return {
      chargebee_subscription: null,
      subscription: null,
      customer: null,
      orderId: '',
      mobileSummaryActive: false,
      countrySetting: null,
      selectedProductIds: '',
      selectedPlan: '',
      displaySummaryInMobileLayout: false
    };
  },
  created() {
    this.orderId = this.$route.query.order_id;
    this.subscription = JSON.parse(localStorage.getItem('subscription'));
    this.customer = JSON.parse(localStorage.getItem('customer'));
    this.chargebee_subscription = JSON.parse(localStorage.getItem('chargebee_subscription'));
    this.countrySetting = chargebeeCheckout.getCountrySetting(this.customer.country);
    this.selectedProductIds = this.subscription.products.map((product) => product.id).join(',');
    this.addProductsToDataLayer(this.orderId);
  },
  mounted() {
    // const GTMSettings = chargebeeCheckout.getGTMSettings(ENV);
    // let gtm = document.createElement('script');
    // gtm.innerHTML = chargebeeCheckout.getGTMInnerHTML(GTMSettings.code);
    // document.head.appendChild(gtm);
    // let gtmBody = document.createElement('noscript');
    // gtmBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTMSettings.code}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    // document.body.appendChild(gtmBody);
  },
  methods: {
    toggleMobileSummaryVisibility: function () {
      this.displaySummaryInMobileLayout = !this.displaySummaryInMobileLayout;
    },
    addProductsToDataLayer: function (subscriptionId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ pagePostType: 'page', pageCategory: ['chargebee-checkout-success-page'] });
      window.dataLayer.push({
        event: 'transaction',
        ecommerce: {
          purchase: {
            actionField: {
              id: subscriptionId,
              affiliation: 'Chargebee checkout',
              coupon: this.subscription.coupon,
              shipping: `${this.subscription.selectedShippingOption.price}`,
              revenue: `${this.subscription.grandTotal / 100}`
            },
            products: [
              ...this.subscription.products,
              this.subscription.plan,
              this.subscription.selectedShippingOption
            ].map((product) => {
              return {
                name: product.name,
                id: product.id,
                price: `${product.price}`,
                quantity: this.subscription.quantity,
                currency: 'AUD'
              };
            })
          }
        }
      });
    }
  }
};
</script>
